import React, { useEffect, useState } from 'react';
export const SalesPopup = () => {
  const [visible, setVisible] = useState(false);
  const [currentFirstName, setCurrentFirstName] = useState('');
  const [currentLastName, setCurrentLastName] = useState('');
  const [currentState, setCurrentState] = useState('');
  const [isPhysicalCopy, setIsPhysicalCopy] = useState(true);
  const [isPremiumCopy, setIsPremiumCopy] = useState(false);
  useEffect(() => {
    // List of random first names
    const firstNames = ['John', 'Emma', 'Michael', 'Olivia', 'William', 'Ava', 'James', 'Sophia', 'Robert', 'Isabella', 'David', 'Mia', 'Joseph', 'Charlotte', 'Thomas', 'Amelia', 'Charles', 'Harper', 'Daniel', 'Evelyn', 'Matthew', 'Abigail', 'Anthony', 'Emily', 'Mark', 'Elizabeth', 'Donald', 'Sofia', 'Steven', 'Avery', 'Paul', 'Ella'];
    // List of random last names
    const lastNames = ['Smith', 'Johnson', 'Williams', 'Brown', 'Jones', 'Garcia', 'Miller', 'Davis', 'Rodriguez', 'Martinez', 'Hernandez', 'Lopez', 'Gonzalez', 'Wilson', 'Anderson', 'Thomas', 'Taylor', 'Moore', 'Jackson', 'Martin', 'Lee', 'Perez', 'Thompson', 'White', 'Harris', 'Sanchez', 'Clark', 'Ramirez', 'Lewis', 'Robinson', 'Walker', 'Young'];
    // Map of US state abbreviations to full names
    const stateMap = {
      AL: 'Alabama',
      AK: 'Alaska',
      AZ: 'Arizona',
      AR: 'Arkansas',
      CA: 'California',
      CO: 'Colorado',
      CT: 'Connecticut',
      DE: 'Delaware',
      FL: 'Florida',
      GA: 'Georgia',
      HI: 'Hawaii',
      ID: 'Idaho',
      IL: 'Illinois',
      IN: 'Indiana',
      IA: 'Iowa',
      KS: 'Kansas',
      KY: 'Kentucky',
      LA: 'Louisiana',
      ME: 'Maine',
      MD: 'Maryland',
      MA: 'Massachusetts',
      MI: 'Michigan',
      MN: 'Minnesota',
      MS: 'Mississippi',
      MO: 'Missouri',
      MT: 'Montana',
      NE: 'Nebraska',
      NV: 'Nevada',
      NH: 'New Hampshire',
      NJ: 'New Jersey',
      NM: 'New Mexico',
      NY: 'New York',
      NC: 'North Carolina',
      ND: 'North Dakota',
      OH: 'Ohio',
      OK: 'Oklahoma',
      OR: 'Oregon',
      PA: 'Pennsylvania',
      RI: 'Rhode Island',
      SC: 'South Carolina',
      SD: 'South Dakota',
      TN: 'Tennessee',
      TX: 'Texas',
      UT: 'Utah',
      VT: 'Vermont',
      VA: 'Virginia',
      WA: 'Washington',
      WV: 'West Virginia',
      WI: 'Wisconsin',
      WY: 'Wyoming'
    };
    // List of full state names
    const states = Object.values(stateMap);
    // Generate random name and state
    const generatePerson = () => {
      const randomFirstName = firstNames[Math.floor(Math.random() * firstNames.length)];
      const randomLastName = lastNames[Math.floor(Math.random() * lastNames.length)];
      const randomState = states[Math.floor(Math.random() * states.length)];
      // Determine product type
      // 35% chance for Premium Hardcover ($97.97)
      // 50% chance for Physical Copy ($34.97)
      // 15% chance for Digital Copy ($19.97)
      const randomValue = Math.random();
      if (randomValue < 0.35) {
        // Premium Hardcover
        setIsPremiumCopy(true);
        setIsPhysicalCopy(true);
      } else if (randomValue < 0.85) {
        // Physical Copy
        setIsPremiumCopy(false);
        setIsPhysicalCopy(true);
      } else {
        // Digital Copy
        setIsPremiumCopy(false);
        setIsPhysicalCopy(false);
      }
      setCurrentFirstName(randomFirstName);
      setCurrentLastName(randomLastName);
      setCurrentState(randomState);
    };
    // Function to handle the display-hide cycle
    const startCycle = () => {
      // Generate new person details
      generatePerson();
      setVisible(true);
      // Hide popup after 3 seconds
      const hideTimer = setTimeout(() => {
        setVisible(false);
        // After 3 seconds of being hidden, start cycle again
        const showTimer = setTimeout(() => {
          startCycle();
        }, 3000);
        return () => clearTimeout(showTimer);
      }, 3000);
      return () => clearTimeout(hideTimer);
    };
    // Start the cycle
    startCycle();
    // Clean up timers on unmount
    return () => {};
  }, []);
  return <div className={`fixed left-1/2 bottom-4 -translate-x-1/2 z-50 w-full max-w-[90%] md:max-w-[400px] bg-white border border-gray-200 rounded-md shadow-md overflow-hidden transition-all duration-500 ease-in-out ${visible ? 'opacity-100 transform translate-y-0' : 'opacity-0 transform translate-y-10 pointer-events-none'}`} data-id="element-143">
      <div className="flex items-center p-2" data-id="element-144">
        <div className="w-10 h-10 flex-shrink-0 mr-3" data-id="element-145">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/d3ro4dQYjsxryNSRLZCBrJ/book-on_table.png" alt="When Schools Become Targets Book" className="w-full h-full object-cover rounded-sm" data-id="element-146" />
        </div>
        <div className="flex-grow" data-id="element-147">
          <h3 className="text-gray-800 font-medium text-sm flex items-center" data-id="element-148">
            <span data-id="element-149">
              {currentFirstName} {currentLastName}
            </span>
            <span className="mx-1 text-xs text-gray-400" data-id="element-150">•</span>
            <span className="text-xs font-normal text-gray-500" data-id="element-151">
              {currentState}
            </span>
          </h3>
          <p className="text-gray-600 text-xs" data-id="element-152">
            Purchase made: $
            {isPremiumCopy ? '74.97' : isPhysicalCopy ? '34.97' : '19.97'}
          </p>
          <p className="text-gray-600 text-xs italic" data-id="element-153">
            When Schools Become Targets
            {isPremiumCopy ? ' - Premium Hardcover' : !isPhysicalCopy ? ' - Digital Copy' : ' - Paperback'}
          </p>
        </div>
        <div className="text-right text-gray-500 text-xs whitespace-nowrap ml-2" data-id="element-154">
          Just now
        </div>
      </div>
    </div>;
};